export class LocalStorage {
  #mPrefix;

  constructor(prefix) {
    this.#mPrefix = prefix;
  }

  set(key, value) {
    const value_json = JSON.stringify(value);
    localStorage.setItem(`${this.#mPrefix}::${key}`, value_json);
  }

  get(key, defvalue) {
    const value_json = localStorage.getItem(`${this.#mPrefix}::${key}`) || null;
    try {
      return JSON.parse(value_json) || defvalue;
    } catch (e) {
      return undefined;
    }
  }

  delete(key) {
    localStorage.removeItem(`${this.#mPrefix}::${key}`);
  }
}

function CreateStorageProxy(prefix, version, watcher) {
  const handler = new LocalStorage(prefix);

  function get(target, prop) {
    //const cached = target[prop];
    //const value = handler.get(String(prop), cached);
    const value = handler.get(String(prop));
    return value;
  }

  function set(target, prop, value) {
    handler.set(String(prop), value);
    target[prop] = value;
    handler.set("____keys", Object.keys(target));

    if (watcher) watcher[prop] = value;
    return true;
  }

  function deleteProperty(target, prop) {
    delete target[prop];
    handler.delete(String(prop));
    handler.set("____keys", Object.keys(target));

    if (watcher) delete watcher[prop];
    return true;
  }

  const initial = {};
  const _version = handler.get("____version");
  const keys = handler.get("____keys", []);
  if (_version != version) {
    console.log("update version");
    for (const key of keys) {
      handler.delete(key);
    }
    handler.delete("____keys");
    handler.set("____version", version);
  } else {
    for (const key of keys) {
      initial[key] = handler.get(key);
    }
  }

  return new Proxy(initial, { get, set, deleteProperty });
}

export { CreateStorageProxy };
